import type { RouteParams } from 'vue-router'

const msLoginProxyOrigin =
  'https://staging-cta.dev-k8s.easybell.de'
const previewHostnamePattern = /^(?:feat|fix)-[a-z0-9-]+\.easybell\.(?:de|com)$/

export function parseNumberParam(param?: RouteParams[string]) {
  const parsedparam = parseInt(param as string)

  if (!param || typeof param !== 'string' || isNaN(parsedparam)) {
    return
  }

  return parsedparam
}

export function getMsLoginFeatureRedirect(
  hash: string,
  currentOrigin: string
): string | undefined {
  if (currentOrigin !== msLoginProxyOrigin) {
    return
  }

  let decodedHash: string

  try {
    decodedHash = decodeURIComponent(hash)
  } catch {
    return
  }

  const state = decodedHash.match(/^.*&state=([^&]*)&.*$/)?.[1]
  const target = state?.match(/^.*\|(https:\/\/[^|]+)$/)?.[1]

  if (!target) {
    return
  }

  try {
    const targetUrl = new URL(target)

    if (
      targetUrl.origin !== target ||
      targetUrl.username ||
      targetUrl.password ||
      !previewHostnamePattern.test(targetUrl.hostname)
    ) {
      return
    }

    return targetUrl.origin
  } catch {
    return
  }
}
